import { render, staticRenderFns } from "./SupporterViewTableItem.vue?vue&type=template&id=6c84af94&scoped=true"
import script from "./SupporterViewTableItem.vue?vue&type=script&lang=js"
export * from "./SupporterViewTableItem.vue?vue&type=script&lang=js"
import style0 from "./SupporterViewTableItem.vue?vue&type=style&index=0&id=6c84af94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84af94",
  null
  
)

export default component.exports